module.exports = __webpack_public_path__ + "static/media/equal.dfa41d4e.png";